import {
  Injectable,
  Type,
  ComponentFactoryResolver,
  ComponentRef,
  ApplicationRef,
  PlatformRef,
  EmbeddedViewRef
} from '@angular/core'

@Injectable()
export class InjectorService {
  private static components: { [name: string]: ComponentRef<any> } = {}

  constructor(
    private applicationRef: ApplicationRef,
    private resolver: ComponentFactoryResolver,
    private platform: PlatformRef,
  ) { }

  getComponent<T> (name: string, defaultComponent: Type<T>): T {
    //if (!InjectorService.components[name]) {  TODO averiguar que consecuencias tiene comentar esto
      const factory = this.resolver.resolveComponentFactory<T>(defaultComponent)
      InjectorService.components[name] = factory.create(this.platform.injector)
      this.applicationRef.attachView(InjectorService.components[name].hostView)
      InjectorService.components[name].onDestroy(
        () => {
          this.applicationRef.detachView(InjectorService.components[name].hostView)
          delete InjectorService.components[name]
        }
      )
      document.body.appendChild((InjectorService.components[name].hostView as EmbeddedViewRef<T>).rootNodes[0])
    //}
    return InjectorService.components[name].instance
  }

}
